import React from 'react'
import { useTranslation } from 'react-i18next'
import { DraftPreview } from './useDraftPreview'

const DraftPreviewNotice: React.FC<{ draft: DraftPreview | null }> = ({ draft }) => {
    const { t } = useTranslation()
    if (!draft) return null

    let detail: string | null = null
    if (draft.status === 'ready') detail = t('Matching rows: {{total}}', { total: draft.totalRows.toLocaleString() })
    if (draft.status === 'empty') detail = t('This filter matches no rows')

    return (
        <div className="flex flex-wrap items-center gap-x-3 px-3 py-2 mb-2 rounded border border-[#E5B611] bg-[#FFF8E1] text-[0.8rem]" data-testid="draft-preview-notice">
            {draft.status === 'loading' && <span>{t('Loading the preview of the proposed filter...')}</span>}
            {draft.status === 'error' && <span>{t("The preview of the proposed filter couldn't be loaded")}</span>}
            {detail !== null && (
                <>
                    <span className="font-semibold">{t('Preview of the proposed filter, not applied yet')}</span>
                    <span>{detail}</span>
                </>
            )}
        </div>
    )
}

export default DraftPreviewNotice
